import { serviceAfterSalesSettings } from "./service-after-sales-settings";
import { serviceAssets } from "./service-assets";
import { serviceCards } from "./service-cards";
import { serviceCategorization } from "./service-categorization";
import { serviceConnectors } from "./service-connectors";
import { serviceConnectorsB } from "./service-connectors-b";
import { serviceConnectorsC } from "./service-connectors-c";
import { serviceConnectorsD } from "./service-connectors-d";
import { serviceConnectorsE } from "./service-connectors-e";
import { serviceExtras } from "./service-extras";
import { serviceField } from "./service-field";
import { serviceImport } from "./service-import";
import { serviceInbox } from "./service-inbox";
import { serviceLeadConvert } from "./service-lead-convert";
import { serviceMerge } from "./service-merge";
import { serviceImportHistory, serviceProductFunnel, serviceRmaReplacement } from "./service-s4-extras";
import { serviceSpares } from "./service-spares";
import { serviceInstallations } from "./service-installations";
import { serviceQuarantine } from "./service-quarantine";
import { serviceReports } from "./service-reports";
import { serviceReportsField } from "./service-reports-field";
import { serviceContact } from "./service-contacts";
import { serviceContracts } from "./service-contracts-ui";
import { serviceOrg } from "./service-organisations";
import { serviceSettings } from "./service-settings";
import { serviceSettingsA } from "./service-settings-a";
import { serviceSettingsB } from "./service-settings-b";
import { serviceCatalogue } from "./service-catalogue";
import { serviceCommerce } from "./service-commerce";
import { serviceOrders } from "./service-orders";
import { serviceRmas } from "./service-rmas";
import { serviceTicketAfterSales } from "./service-ticket-after-sales";
import { serviceTicketDetail } from "./service-ticket-detail";
import { serviceTickets } from "./service-tickets";
import { serviceVisits } from "./service-visits";

/** Service Desk (M27) console shells: plan lock, flag-off and not-yet-built states (S0). */
export const service = {
  settings: { ...serviceSettings, ...serviceSettingsA, ...serviceSettingsB, assetsWarranty: serviceAfterSalesSettings.assetsWarranty, visitTemplates: serviceAfterSalesSettings.visitTemplates, nav: { ...serviceSettingsA.nav, ...serviceSettingsB.nav, ...serviceQuarantine.nav, ...serviceAfterSalesSettings.nav, import: serviceImport.nav, ...serviceCommerce.nav } },
  lock: { available: "Available on {{plan}}" },
  upgrade: {
    title: "{{area}} is included from the {{plan}} plan",
    body: "Service Desk brings tickets, client organisations and, on Pro, assets, field visits and orders into one place. Upgrade to switch on {{area}}.",
    cta: "See plans",
  },
  off: {
    title: "Service Desk isn't switched on for this workspace",
    body: "It is being rolled out workspace by workspace. Nothing is missing on your side; ask the Sagot team if you would like early access.",
  },
  soon: {
    title: "{{area}} opens with the Service Desk release",
    body: "Your plan already includes it. The screen arrives in the next release and your data will be waiting.",
  },
  error: {
    title: "Service Desk couldn't load",
    body: "Check your connection and try again. Nothing was changed.",
    retry: "Try again",
  },
  chips: {
    actionNeeded: "Action needed",
    category: {
      new: "New",
      open: "Open",
      pending: "Pending (waiting for client)",
      on_hold: "On hold (third party)",
      resolved: "Resolved",
      closed: "Closed",
    },
    status: {
      staff: { new: "New", open: "Open", pending: "Pending", on_hold: "On hold", resolved: "Resolved", closed: "Closed" },
      client: {
        new: "Received",
        open: "In progress",
        pending: "Waiting for your reply",
        on_hold: "On hold",
        resolved: "Resolved — please confirm",
        closed: "Closed",
      },
    },
    priority: { urgent: "Urgent", high: "High", normal: "Normal", low: "Low" },
    verification: {
      verified: "Verified",
      unverified: "Unverified",
      method: { widget_jwt: "Website sign-in", email_otp: "E-mail code", magic_link: "Magic link", staff_verified: "Checked by staff" },
    },
    sla: {
      metric: { first_response: "First reply", next_response: "Next reply", resolution: "Resolution", onsite_response: "On-site response" },
      met: "{{metric}} met",
      due: "{{metric}} due {{due}}",
      onTrack: "{{metric}} on track",
      dueSoon: "{{metric}} due soon",
      breached: "{{metric}} breached",
      paused: "{{metric}} paused",
      pausedFor: "Paused: {{reason}}",
      none: "No {{metric}} target",
      percentLeft: "{{percent}}% of the time left",
      allTargets: "All targets for this ticket",
      noTargets: "No SLA targets",
      targetLine: "{{text}} ({{percent}}% left)",
    },
  },
  back: "Back to dashboard",
  loading: "Loading",
  areas: {
    tickets: { title: "Tickets", summary: "Every client request in one queue, with owners, due times and replies." },
    organisations: { title: "Organisations", summary: "The companies and institutions you serve, with their sites and people." },
    contacts: { title: "Contacts", summary: "Client people, how they were verified and which organisation they belong to." },
    assets: { title: "Assets", summary: "Installed equipment with warranty, contracts and service history." },
    installations: { title: "Installations", summary: "Delivery and commissioning projects with stages and open items." },
    visits: { title: "Field visits", summary: "Schedule engineers, dispatch visits and collect reports and sign-off." },
    orders: { title: "Orders", summary: "Orders, quotes and approvals placed through the assistant." },
    catalogue: { title: "Catalogue", summary: "Products and prices synced from your order system." },
    "service-reports": { title: "Service reports", summary: "Response times, resolution, satisfaction and workload at a glance." },
    "service-settings": { title: "Service settings", summary: "Ticket types, fields, statuses, routing, SLAs and automation." },
  },
  assets: serviceAssets,
  contracts: serviceContracts,
  installations: serviceInstallations,
  visits: serviceVisits,
  field: serviceField,
  extras: serviceExtras,
  org: serviceOrg,
  contact: serviceContact,
  import: serviceImport,
  tickets: serviceTickets,
  ticketDetail: { ...serviceTicketDetail, after: serviceTicketAfterSales },
  rmas: serviceRmas,
  orders: serviceOrders,
  catalogue: serviceCatalogue,
  commerce: serviceCommerce.commerce,
  ordering: serviceCommerce.ordering,
  categorization: serviceCategorization,
  reports: { ...serviceReports, tabs: { ...serviceReports.tabs, ...serviceReportsField.tabs, ...serviceCategorization.tabs }, field: serviceReportsField.field, insight: serviceReportsField.insight },
  connectors: { ...serviceConnectors, ...serviceConnectorsB, ...serviceConnectorsC, ...serviceConnectorsD, ...serviceConnectorsE },
  quarantine: serviceQuarantine,
  inbox: serviceInbox,
  cards: serviceCards,
  merge: serviceMerge,
  spares: serviceSpares,
  leadConvert: serviceLeadConvert,
  rmaReplacement: serviceRmaReplacement,
  importHistory: serviceImportHistory,
  productFunnel: serviceProductFunnel,
} as const;
